import { useContext } from "react";
import { LoadingContext } from "../context/loading-context";

export function useLoadingContext() {
	const context = useContext(LoadingContext);
	if (!context) {
		throw new Error("useLoadingContext must be used within LoadingContextProvider");
	}
	return context;
}
